export function ComplianceBadge({ status, label, size = "sm" }) {
  const cls = {
    valid: "compliance-valid",
    expired: "compliance-expired",
    pending: "compliance-pending",
  }[status] || "compliance-pending";
  const px = size === "lg" ? "px-4 py-1.5 text-sm" : "px-3 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ${px} font-semibold ${cls}`}
      data-testid={`compliance-badge-${status}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label || status.toUpperCase()}
    </span>
  );
}
